<mat-toolbar class="header">
  <span class="title">Application admins</span>
  <span class="example-spacer"></span>

  <app-search-field [control]="searchControl"></app-search-field>

  <app-button (click)="openDialogInviteUser()">
    <mat-icon>add</mat-icon>
    Add new admin
  </app-button>
</mat-toolbar>

<div class="content">
  <ng-container #table></ng-container>
</div>
